import script from "./ThuChiNhapVao.vue?vue&type=script&setup=true&lang=js"
export * from "./ThuChiNhapVao.vue?vue&type=script&setup=true&lang=js"

import "./ThuChiNhapVao.vue?vue&type=style&index=0&id=c4d894f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4d894f6"]])

export default __exports__